<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex xs12 sm12 md12 lg12 xl12>
        <!-- only in xl,lg,md screen -->
        <v-layout wrap justify-center class="hidden-md-and-down">
          <v-flex xs12>
            <v-layout wrap justify-start>
              <v-flex xs12 sm6>
                <v-img
                  src="./../../assets/Images/landingpage/homeimage.webp"
                  cover
                ></v-img>
              </v-flex>
              <v-flex xs12 sm6>
                <v-layout wrap justify-center>
                  <v-flex xs12 pa-3>
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span class="corporatemainhead"
                          >Be Our Corporate Partner</span
                        >
                      </v-flex>
                      <v-flex xs12 text-left pt-3>
                        <span
                          style="
                            font-family: poppinsregular;
                            font-size: 20px;
                            font-weight: 700;
                            color: #3d673a;
                          "
                          >Partnering with the Wildlife Trust of India (WTI)
                          offers your company a unique opportunity to contribute
                          to the conservation of India’s rich biodiversity in a
                          rapidly evolving world.</span
                        >
                      </v-flex>
                      <v-flex xs12 text-left pt-3>
                        <span
                          style="
                            font-family: poppinsbold;
                            font-size: 18px;
                            font-weight: 700;
                            color: #3d673a;
                          "
                          >By joining us as a Corporate Partner, you can:</span
                        >
                      </v-flex>
                      <v-flex xs12 text-left pt-3 pl-3>
                        <span
                          style="
                            font-family: poppinsregular;
                            font-size: 16px;
                            font-weight: 600;
                            color: #3d673a;
                          "
                          >● create strong positive brand association and
                          reach,<br />● advance your Environmental, Social, and
                          Governance (ESG) commitments<br />● progress towards
                          the Global Biodiversity Framework<br />● fulfill your
                          Corporate Social Responsibility (CSR) objectives<br />●
                          support meaningful philanthropic initiatives
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap justify-center>
                      <v-flex xs12 sm9 text-center pt-5>
                        <span
                          style="
                            font-family: poppinsbold;
                            font-size: 22px;
                            font-weight: 700;
                            color: #3d673a;
                          "
                          >Contact our partnership liaison today and find out
                          how your organisation can support</span
                        >
                      </v-flex>
                      <v-flex xs12 text-center pt-3>
                        <v-btn rounded color="#efb727" @click="setActiveItem()"
                          ><span
                            style="
                              font-family: poppinsbold;
                              font-size: 15px;
                              font-weight: 700;
                              color: #3d673a;
                              text-transform: justify;
                              text-decoration: underline;
                            "
                            >Click Here</span
                          ></v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- only in sm and xs -->
        <v-layout wrap justify-center fill-height class="hidden-lg-and-up">
          <v-flex xs12 sm12>
            <v-layout wrap justify-center>
              <v-flex xs12 pa-5>
                <v-layout wrap justify-center>
                  <v-flex xs12 text-left>
                    <span class="corporatemainhead"
                      >Be Our Corporate Partner</span
                    >
                  </v-flex>
                  <v-flex xs12 text-left pt-3>
                    <span
                      style="
                        font-family: poppinsregular;
                        font-size: 20px;
                        font-weight: 700;
                        color: #3d673a;
                      "
                      >Partnering with the Wildlife Trust of India (WTI) offers
                      your company a unique opportunity to contribute to the
                      conservation of India’s rich biodiversity in a rapidly
                      evolving world.</span
                    >
                  </v-flex>
                  <v-flex xs12 text-left pt-3>
                    <span
                      style="
                        font-family: poppinsbold;
                        font-size: 18px;
                        font-weight: 700;
                        color: #3d673a;
                      "
                      >By joining us as a Corporate Partner, you can:</span
                    >
                  </v-flex>
                  <v-flex xs12 text-left pt-3 pl-3>
                    <span
                      style="
                        font-family: poppinsregular;
                        font-size: 16px;
                        font-weight: 600;
                        color: #3d673a;
                      "
                      >● create strong positive brand association and reach,<br />●
                      advance your Environmental, Social, and Governance (ESG)
                      commitments<br />● progress towards the Global
                      Biodiversity Framework<br />● fulfill your Corporate
                      Social Responsibility (CSR) objectives<br />● support
                      meaningful philanthropic initiatives
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-center>
                  <v-flex xs12 sm9 lg9 text-center pt-5>
                    <span
                      style="
                        font-family: poppinsbold;
                        font-size: 22px;
                        font-weight: 700;
                        color: #3d673a;
                      "
                      >Contact our partnership liaison today and find out how
                      your organisation can support</span
                    >
                  </v-flex>
                  <v-flex xs12 text-center pt-3>
                    <v-btn rounded color="#efb727" @click="setActiveItem()"
                      ><span
                        style="
                          font-family: poppinsbold;
                          font-size: 15px;
                          font-weight: 700;
                          color: #3d673a;
                          text-transform: justify;
                          text-decoration: underline;
                        "
                        >Click Here</span
                      ></v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12>
            <v-img
              src="./../../assets/Images/landingpage/homeimage.webp"
              cover
            >
            </v-img>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  methods: {
    setActiveItem() {
      this.scrollTo("contactus");
    },
    scrollTo(id) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>
<style scoped>
.custom-btn {
  transition: all 0.3s ease;
  border-bottom: 3px solid black;
}

.custom-btn:hover {
  background-color: white !important;
  color: green !important;
  border-bottom: 3px solid black;
}

/* .bacimg {
  background-image: url("./../../assets/Images/landingpage/corporateimage.jpg");
} */
.corporatemainhead {
  font-family: poppinsbold;
  color: #efb727;
  font-size: 40px;
  text-transform: uppercase;
  font-weight: 700;
}
</style>